import { DropdownWithCheckboxesItem } from "@/components/DropdownWithCheckboxes/DropdownWithCheckboxes";

export const ALL_SENDERS_ITEM: DropdownWithCheckboxesItem = { id: "All", title: "All" };

/**
 * Normalizes the sender multi-select of a campaign node so that "All" and
 * concrete senders are mutually exclusive:
 * - selecting "All" clears every concrete sender,
 * - selecting a concrete sender removes "All",
 * - an empty selection falls back to "All".
 */
export const normalizeSenderSelection = (
	value: DropdownWithCheckboxesItem[],
	currentSenders?: DropdownWithCheckboxesItem[]
): DropdownWithCheckboxesItem[] => {
	const current = currentSenders?.length ? currentSenders : [ALL_SENDERS_ITEM];

	const addedValue = value.find((v) => !current.map((s) => s.id).includes(v.id));
	const removedValue = current.find((v) => !value.map((s) => s.id).includes(v.id));

	if (addedValue?.id === ALL_SENDERS_ITEM.id) {
		return [ALL_SENDERS_ITEM];
	}

	const normalized =
		addedValue || removedValue?.id === ALL_SENDERS_ITEM.id
			? value.filter((v) => v.id !== ALL_SENDERS_ITEM.id)
			: value;

	return normalized.length ? normalized : [ALL_SENDERS_ITEM];
};
